<!--
 * @ Author: Your name
 * @ Create Time: 2019-07-30 10:14:37
 * @ Modified by: Your name
 * @ Modified time: 2019-07-31 16:21:47
 * @ Description: 客户端版本管理
 -->
<template>
  <div class="content-wrapper">
    <div class="tool-bar">
      <el-button type="danger" size="small" icon="el-icon-upload2"
        @click="uploadInstallPackage()">上传安装包</el-button>
      <el-button type="warning" size="small" icon="el-icon-bottom"
        @click="handleBtn('down')">下架</el-button>
      <el-button type="info" size="small" icon="el-icon-top"
        @click="handleBtn('up')">上架</el-button>
    </div>
    <table-pagination
      ref="table"
      :tableData="tableData"
      :height='400'
      :loading='tableLoading'
      service
      @service-fn="handleService"
      @row-click="rowClick">
      <el-table-column label="" width="45" align="center">
        <template slot-scope="scope">
          <el-radio class="radio" v-model="tableRadio" :label="scope.$index">&nbsp;</el-radio>
        </template>
      </el-table-column>
      <el-table-column prop="packageName" label="安装包名称" align="center"/>
      <el-table-column prop="versionNumber" label="版本号" align="center"/>
      <el-table-column prop="ftpPath" label="ftp文件下载路径" align="center"/>
      <el-table-column prop="createDate" label="上传时间" align="center" sortable
        :formatter='formatterTime' show-overflow-tooltip/>
      <el-table-column prop="packageStatus" label="状态" align="center"
        :formatter='formatStatus'>
      </el-table-column>
      <el-table-column prop="remarks" label="状态信息" align="center"/>
    </table-pagination>
    <!-- 上传安装包弹窗 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="uploadInstallPackageShow"
      width="700px"
      >
      <dialog-main ref="dialogForm"
        :visible.sync='uploadInstallPackageShow'
        :uploadInstallPackageShow='uploadInstallPackageShow'
        :clickConfirm='uploadClick'
        @startSubmit='startSubmit'
        @endSubmit='endSubmit'>
      </dialog-main>
      <span slot="footer" class="dialog-footer">
        <el-button @click="uploadInstallPackageShow = false"
          size="small" type="info">取 消</el-button>
        <el-button @click="uploadInstallPackageConfirm()" size="small"
          type="primary" :loading="confirmBtn">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import tables from '../../mixins/table'
import dialogMain from './dialogMain.vue'
import { VERSIONMANAGE } from '../../libs/api'
import handleBtn from '../../mixins/dialog/handleBtn'

export default {
  name: 'clientVersionManagement',
  mixins: [tables, handleBtn],
  components: { dialogMain },
  data() {
    return {
      tableLoading: false,
      uploadClick: '',
      dialogTitle: '上传安装包',
      uploadInstallPackageShow: false,
      confirmBtn: false,
      formData: {
        pageNum: 1,
        pageSize: 10,
        orderBy: ''
      },
      dic: {
        status: {
          1: '正常',
          2: '已下架'
        }
      },
      searchUrl: VERSIONMANAGE.GET_LIST,
      packageStatusUrl: VERSIONMANAGE.PACKAGESTATUS
    }
  },
  watch: {
    uploadInstallPackageShow(val) {
      if (!val) { // 关闭弹窗， 清空传递的值
        this.uploadClick = ''
      }
    }
  },
  mounted() {
    // table 数据表查询
    this.searchTableData()
  },
  methods: {
    searchTableData() {
      this.handleSearch(this.searchUrl, this.formData)
    },
    uploadInstallPackage() { // 上传安装包
      this.uploadInstallPackageShow = true
    },
    uploadInstallPackageConfirm() { // 确认上传安装包
      this.uploadClick = `true-${Date.now()}`
    },
    handlePackageStatus(type) { // 上架、下架
      const isUPOrDown = this.isUP(type)
      const { uuid, packageStatus } = this.selection[0]
      // 判断已经上架的不能重复上架，下架如此
      const resIsPutaway = this.isPutaway(packageStatus, isUPOrDown)
      if (resIsPutaway) {
        return false
      }
      // 上下架请求接口
      this.upOrDownRequest(isUPOrDown.packageStatus, uuid, isUPOrDown)
      return true
    },
    upOrDownRequest(packageStatus, uuid, isUPOrDown) {
      this.$http.post(this.packageStatusUrl, { packageStatus, uuid })
        .then(res => {
          if (res.data.code === 1) {
            this.$notify.success({
              title: '提示',
              message: `${isUPOrDown.msg} 成功`
            })
            this.searchTableData()
          } else {
            this.$notify.error({
              title: '错误',
              message: res.data.msg || `${isUPOrDown.msg} 失败`
            })
          }
        })
    },
    isPutaway(status, isUPOrDown) { // 判断是否已经上、下架
      const { packageStatus, msg } = isUPOrDown
      status = String(status)
      if (packageStatus === status) {
        this.$notify.error({
          title: '错误',
          message: `该条数据已经${msg}，不能重复${msg}`
        })
        return true
      }
      return false
    },
    isUP(type) {
      let packageStatus = ''
      let msg = ''
      if (type === 'up') {
        packageStatus = '1'
        msg = '上架'
      } else {
        packageStatus = '2'
        msg = '下架'
      }
      return {
        packageStatus,
        msg
      }
    },
    formatStatus(row, column, cellValue) { // 状态
      return this.dic.status[cellValue]
    },
    startSubmit() { // 弹窗开始点击
      this.confirmBtn = true // 开始弹窗的按钮的loading 状态
    },
    endSubmit(param) { // 弹窗结束点击
      this.confirmBtn = false // 结束弹窗中按钮的loading状态
      if (!param) return
      this.uploadInstallPackageShow = false // 关闭弹窗
      this.searchTableData() // 重新刷新table数据
    }
  }
}
</script>
<style lang="sass" scoped>
</style>
